import { ExclamationTriangleIcon } from '@heroicons/react/24/outline';
import PropTypes from 'prop-types';

// Shown when the services lookup fails. `onRetry` is wired to the query's
// refetch. The button is explicitly type="button" because this renders inside a
// <Form>/<form>, where an untyped button would submit it.
const ServicesError = ({ onRetry }) => (
	<div className="mt-4 alert alert-error" role="alert">
		<ExclamationTriangleIcon className="block w-6 h-6" />
		<span>We couldn&apos;t load services right now. Please try again.</span>
		<button type="button" className="btn btn-sm" onClick={onRetry}>
			Retry
		</button>
	</div>
);

ServicesError.propTypes = {
	onRetry: PropTypes.func.isRequired,
};

export default ServicesError;
